import "./style.css";

export const Footer = ({ onServiceClick, onContactClick }) => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          {/* REGISTRATION */}
          <div className="footer-column">
            <h3 className="footer-heading">REGISTRATION</h3>
            <ul className="footer-links">
              <li onClick={() => onServiceClick("Private Limited Company")}>Private Limited Company</li>
              <li onClick={() => onServiceClick("Limited Liability Partnership (LLP)")}>Limited Liability Partnership (LLP)</li>
              <li onClick={() => onServiceClick("One Person Company")}>One Person Company</li>
              <li onClick={() => onServiceClick("Section 8 Company (Non Profit Organization)")}>Section 8 Company (Non Profit Organization)</li>
              <li onClick={() => onServiceClick("Public Limited Company")}>Public Limited Company</li>
              <li onClick={() => onServiceClick("Gst Registration")}>GST Registration</li>
              <li onClick={() => onServiceClick("Professional Tax Registration (P-Tax)")}>Professional Tax Registration (P-Tax)</li>
              <li onClick={() => onServiceClick("Pan & Tan Registration")}>Pan & Tan Registration</li>
              <li onClick={() => onServiceClick("Udyam / MSME Registration")}>Udyam / MSME Registration</li>
              <li onClick={() => onServiceClick("Startup India Registration")}>Startup India Registration</li>
              <li onClick={() => onServiceClick("Import Export Code")}>Import Export Code</li>
            </ul>
          </div>
          
          {/* TAX & COMPLIANCES */}
          <div className="footer-column">
            <h3 className="footer-heading">TAX & COMPLIANCES</h3>
            <ul className="footer-links">
              <li onClick={() => onServiceClick("Individual")}>Income Tax Filing - Individual</li>
              <li onClick={() => onServiceClick("LLP")}>Income Tax Filing - LLP</li>
              <li onClick={() => onServiceClick("Company")}>Income Tax Filing - Company</li>
              <li onClick={() => onServiceClick("AOP")}>Income Tax Filing - AOP</li>
              <li onClick={() => onServiceClick("BOI")}>Income Tax Filing - BOI</li>
              <li onClick={() => onServiceClick("TDS & TCS Filing")}>TDS & TCS Filing</li>
              <li onClick={() => onServiceClick("Tax Audit (Form 3CA / 3CB / 3CD)")}>Tax Audit (Form 3CA / 3CB / 3CD)</li>
              <li onClick={() => onServiceClick("Statutory Audit")}>Statutory Audit</li>
              <li onClick={() => onServiceClick("Pan Correction and Reissue")}>Pan Correction and Reissue</li>
              <li onClick={() => onServiceClick("Gst Registrations & Services")}>GST Registrations & Services</li>
              <li onClick={() => onServiceClick("GST Return Filing (GSTR 1, 3B, 4, 9/9C)")}>GST Return Filing (GSTR 1, 3B, 4, 9/9C)</li>
              <li onClick={() => onServiceClick("GST Audit & Certification")}>GST Audit & Certification</li>
              <li onClick={() => onServiceClick("E-invoicing & E-way bill Compliance")}>E-invoicing & E-way bill Compliance</li>
            </ul>
          </div>
          
          {/* TRADEMARK & CERTIFICATIONS */}
          <div className="footer-column">
            <h3 className="footer-heading">TRADEMARK & CERTIFICATIONS</h3>
            <ul className="footer-links">
              <li onClick={() => onServiceClick("Trademark Applications & Filing")}>Trademark Applications & Filing</li>
              <li onClick={() => onServiceClick("TradeMark Search And Advisory")}>TradeMark Search And Advisory</li>
              <li onClick={() => onServiceClick("Trademark Renewal")}>Trademark Renewal</li>
              <li onClick={() => onServiceClick("Income / Net worth Certificates")}>Income / Net worth Certificates</li>
              <li onClick={() => onServiceClick("Turn over or Profit Certificates")}>Turn over or Profit Certificates</li>
              <li onClick={() => onServiceClick("Statutory Certificates")}>Statutory Certificates</li>
              <li onClick={() => onServiceClick("Provisional/Projected Financial Certificate (Project Report)")}>Provisional/Projected Financial Certificate (Project Report)</li>
              <li onClick={() => onServiceClick("Working Capital Certificate")}>Working Capital Certificate</li>
              <li onClick={() => onServiceClick("Stock / BookDebt Certificate")}>Stock / BookDebt Certificate</li>
              <li onClick={() => onServiceClick("Fund Flow Certificate")}>Fund Flow Certificate</li>
            </ul>
          </div>
          
          {/* MCA SERVICES */}
          <div className="footer-column">
            <h3 className="footer-heading">MCA SERVICES</h3>
            <ul className="footer-links">
              <li onClick={() => onServiceClick("Private Limited Company Registration")}>Private Limited Company Registration</li>
              <li onClick={() => onServiceClick("One Person Company Registration (OPC)")}>One Person Company Registration (OPC)</li>
              <li onClick={() => onServiceClick("Limited Liability Partnership Registration")}>Limited Liability Partnership Registration</li>
              <li onClick={() => onServiceClick("Post Incorporation Compliances (INC-20A, ADT-1, etc)")}>Post Incorporation Compliances</li>
              <li onClick={() => onServiceClick("Conversion of Entity Type (LLP to Pvt ltd, etc)")}>Conversion of Entity Type</li>
              <li onClick={() => onServiceClick("AOC-4 / AOC-4 XBRL - Filing of Financial Statements")}>AOC-4 Filing of Financial Statements</li>
              <li onClick={() => onServiceClick("MGT-7 / MGT-7A - Annual Return Filing")}>MGT-7 Annual Return Filing</li>
              <li onClick={() => onServiceClick("ADT-1 - Appointment of Auditor")}>ADT-1 Appointment of Auditor</li>
              <li onClick={() => onServiceClick("DIR-3 KYC / DIR-3 KYC Web - Directory KYC")}>DIR-3 KYC Directory KYC</li>
              <li onClick={() => onServiceClick("DIN Application / Modification")}>DIN Application / Modification</li>
              <li onClick={() => onServiceClick("Director Resignation or Appointment Filings")}>Director Resignation or Appointment</li>
              <li onClick={() => onServiceClick("Drafting of MOA / AOA Amendments")}>Drafting of MOA / AOA Amendments</li>
            </ul>
          </div>
          
          {/* ONLINE CA SERVICES */}
          <div className="footer-column">
            <h3 className="footer-heading">ONLINE CA SERVICES</h3>
            <ul className="footer-links">
              <li onClick={() => onServiceClick("Online CA Services")}>Online CA Services</li>
              <li onClick={() => onServiceClick("Virtual CA Consultation")}>Virtual CA Consultation</li>
              <li onClick={() => onServiceClick("Financial Advisory")}>Financial Advisory</li>
              <li onClick={() => onServiceClick("Tax Planning")}>Tax Planning</li>
              <li onClick={() => onServiceClick("Accounting Services")}>Accounting Services</li>
              <li onClick={() => onServiceClick("Payroll Management")}>Payroll Management</li>
              <li onClick={() => onServiceClick("Bookkeeping Services")}>Bookkeeping Services</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="footer-cta">
        <div className="footer-cta-content">
          <h2 className="footer-cta-title">Ready to Transform Your Business?</h2>
          <p className="footer-cta-subtitle">Get started in minutes</p>
          <p className="footer-cta-subtitle">apkadostca@gmail.com</p>
          <button className="footer-cta-btn" onClick={onContactClick}>Contact Us Now</button>
        </div>
      </div>
    </footer>
  );
};


